import { biaAccessTechOptions } from "@/common/const";
import quotesRender from "@/common/const/elementsList/quotesRender.const";
import { ColumnsStrategy, PriceType } from "@/common/types";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  MbpsCell,
  OptionsCell,
  QuoteStatusCell,
} from "@/components/TableComponents";
import { Tag } from "antd";

const biaQuoteLineCustomerStrategy: ColumnsStrategy[] = [
  {
    label: <DefaultHeadColumns text="Quote Line ID" key={"Quote Line ID"} />,
    name: "id",

    render: (value) => {
      return <DefaultTextColumn text={value} key={value} className="py-0" />;
    },
  },
  {
    label: <DefaultHeadColumns text="Product" key={"product"} />,
    name: "price",

    render: (value: PriceType) => {
      return (
        <OptionsCell
          options={quotesRender}
          value={value?.type}
          key={`${value?.id} + ${value?.type}`}
        />
      );
    },
  },
  {
    label: <DefaultHeadColumns text="Status" key={"Status"} />,
    name: "status",

    render: (value: any, record: any) => (
      <QuoteStatusCell status={value} key={`${record?.id}+${value}`} />
    ),
  },
  {
    label: (
      <DefaultHeadColumns text="Last Mile Provider" key="Last Mile Provider" />
    ),
    name: "price",

    render: (value: PriceType) => (
      <DefaultTextColumn
        text={value?.lastMileProvider}
        key={`${value?.id}+ ${value?.lastMileProvider}`}
        className="py-0"
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="Download Speed (in Mbps)" />,
    name: "price",
    className: "!border-none",
    render: (value: PriceType) => (
      <MbpsCell value={value?.downloadSpeed?.toString()} key={value?.id} />
    ),
  },
  {
    label: <DefaultHeadColumns text="Upload Speed (in Mbps)" />,
    name: "price",
    render: (value: PriceType) => (
      <MbpsCell
        value={value?.uploadSpeed?.toString()}
        key={`${value?.id} + ${value?.uploadSpeed}`}
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="Contract Term " key={"Contract Term "} />,
    name: "price",
    render: (value: PriceType) => (
      <DefaultTextColumn
        text={
          value?.contractTerm?.toString()
            ? value?.contractTerm?.toString() + " Months"
            : "No data"
        }
        key={`${value?.id}+${[value?.contractTerm]}`}
        className="py-0"
      />
    ),
  },
  {
    label: (
      <DefaultHeadColumns text="Access Technology" key={"Access Technology"} />
    ),
    name: "price",
    render: (value: PriceType) => (
      <OptionsCell
        options={biaAccessTechOptions}
        value={value?.AccessTechnology?.toString() || "No data"}
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="OTC" key={"OTC"} />,
    name: "price",
    render: (value: PriceType) => (
      <DefaultTextColumn
        text={value?.targetOTC || 0}
        key={value?.id + "OTE"}
        className="py-0"
        labelClassName="text-primary"
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="MRC" key={"MRC"} />,
    name: "price",
    render: (value: PriceType) => (
      <DefaultTextColumn
        text={value?.targetMRC || 0}
        key={value?.id + "MRE"}
        className="py-0"
        labelClassName="text-primary"
      />
    ),
  },

  {
    label: <DefaultHeadColumns text="Quote Type" key={"Quote Type"} />,
    name: "quoteType",
    render: (value) => {
      if (value === "Firm") {
        return (
          <Tag
            color="green"
            bordered={false}
            className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
          >
            {value}
          </Tag>
        );
      }
      return (
        <Tag
          color="gold"
          bordered={false}
          className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
        >
          {value}
        </Tag>
      );
    },
  },
];
export default biaQuoteLineCustomerStrategy;
